import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAlarmSettingListQuery, useSetAlarmMutation } from "src/api/alarmAPI";
import Switch from "../common/Switch";
import styled from "styled-components";

const EtcAlarmSettingItem = () => {
  const navigate = useNavigate();
  const alarmSetList = useAlarmSettingListQuery("");
  const { refetch } = useAlarmSettingListQuery("");
  const [setAlarmUpdate, { isError: setAlarmIsError, isSuccess: setAlarmIsSuccess }] = useSetAlarmMutation();

  useEffect(() => {
    if (setAlarmIsSuccess) {
      refetch();
    }
  }, [setAlarmIsSuccess]);

  useEffect(() => {
    if (setAlarmIsError || alarmSetList.isError) {
      navigate("/error");
    }
  }, [setAlarmIsError, alarmSetList.isError]);

  const alarmSet = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAlarmUpdate({
      push_type: e.target.dataset.type ? e.target.dataset.type : "",
      YN: e.target.checked ? "Y" : "N",
    });
  };

  return (
    <>
      {alarmSetList.isSuccess && (
        <>
          <li>
            <SwitchSet>
              <div>
                <p className="title">댓글 알림</p>
              </div>
              <div>
                <Switch id="alarm-setting05" checked={alarmSetList.data.data.COMMENT === "Y" ? true : false} onChange={alarmSet} dataType="COMMENT" />
              </div>
            </SwitchSet>
          </li>
          <li>
            <SwitchSet>
              <div>
                <p className="title">SKU 알림</p>
              </div>
              <div>
                <Switch id="alarm-setting06" checked={alarmSetList.data.data.SKU === "Y" ? true : false} onChange={alarmSet} dataType="SKU" />
              </div>
            </SwitchSet>
          </li>
        </>
      )}
    </>
  );
};

const SwitchSet = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin()}
  .title {
    font-size: 16px;
    font-weight: 500;
  }
`;

export default EtcAlarmSettingItem;
